import axiosInstance from '@/utils/api.js'

var state = {
  telephoneOperators: [],
  telephoneOperatorsService: []
}

var getters = {
  TELEPHONE_OPERATORS: (state) => {
    return state.telephoneOperators
  },
  TELEPHONE_OPERATORS_SERVICE: (state) => {
    return state.telephoneOperatorsService
  }
}

var mutations = {
  SET_TELEPHONE_OPERATORS: (state, payload) => {
    state.telephoneOperators = payload
  },
  SET_TELEPHONE_OPERATORS_SERVICE: (state, payload) => {
    state.telephoneOperatorsService = payload
  }
}

var actions = {
  GET_TELEPHONE_OPERATORS: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/suppliers')
    if (result.status === 200) {
      context.commit('SET_TELEPHONE_OPERATORS', result.data)
    }
  },
  GET_SUPPLIER_SERVICE: async (context, payload) => {
    let result = await axiosInstance.get('/settings/tel_suppliers/service?supplier_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_TELEPHONE_OPERATORS_SERVICE', result.data)
    }
  },
  CREATE_TELEPHONE_SUPPLIER_FULL: (context, payload) => {
    return axiosInstance.post('/settings/suppliers_full', payload)
  },
  CREATE_TELEPHONE_SUPPLIER: (context, payload) => {
    return axiosInstance.post('/settings/suppliers', payload)
  },
  UPDATE_TELEPHONE_SUPPLIER: (context, payload) => {
    return axiosInstance.put('/settings/suppliers', payload)
  },
  CREATE_TELEPHONE_SUPPLIER_SERVICE: (context, payload) => {
    return axiosInstance.post('/settings/tel_suppliers/service', payload)
  },
  UPDATE_TELEPHONE_SUPPLIER_SERVICE: (context, payload) => {
    return axiosInstance.put('/settings/tel_suppliers/service', payload)
  },
  DELETE_TELEPHONE_OPERATORS: (context, payload) => {
    return axiosInstance.delete('/settings/suppliers?supplier_id=' + payload)
  },
  GET_MAKE_PAYMENT_FOR_SUPPLIER: (context, payload) => {
    return axiosInstance.get('/settings/make_payment_for_supplier?supplier_id=' + payload.id +
    '&sum=' + payload.sum +
    '&currency_type=' + payload.currency +
    '&reason_of_payment=' + payload.reason +
    '&in_type=' + payload.inType)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/telephoneOperators.js